<template>
  <div class="car-list table-container" :style="{
      'min-height': styles.carListStyles.minHeight,
      'max-height': styles.carListStyles.maxHeight,
    }"
  >
    <table class="table type-default font-md">
      <thead>
        <tr>
          <th>車両</th>
          <th>状態</th>
          <th>車種</th>
          <th>更新時刻</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="car in carState.cars"
          :key="car.deviceId"
          @click="onCarListRowClick(car)"
          class="table-row"
          :class="{'selected': car.isSelected}"
        >
          <td><span>{{car.device.carName}}</span></td>
          <td><span>{{car.statusDisp}}</span></td>
          <td><span>{{car.device.carKindDisp}}</span></td>
          <td><span>{{dtFormat(car.ts)}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="disp-option-list component-box box-default mt8">
    <div class="box-header-bar">
      表示切替
    </div>
    <div class="form-group group-scope">
      <label class="form-control-label mr2 mb0">表示車両:</label>
      <select v-model="carState.carSearchParams.groupScopeId" class="custom-select" @change="onCarSearchParamsChange">
        <option :value="null">全て</option>
        <option v-for="(value, name) in groupScopeMap" :key="name" :value="name">
          {{ value.label }}
        </option>
      </select>
    </div>
    <div class="form-group checkboxes">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="carState.showCarIcons"
          @change="updateShowCarIcons"
          id="disp-option-list-show-car-icons"
        >
        <label class="custom-control-label" for="disp-option-list-show-car-icons">
          車両アイコン
        </label>
      </div>
    </div>
  </div>
  <div class="data-layer-list component-box box-default mt8">
    <div class="box-header-bar">
      レイヤーデータ表示
    </div>
    <div class="box-contents">
      <template v-for="(e, idx) in geoItemsMeta.list" :key="idx">
        <div class="form-group" :style="{'margin-bottom': '0.6rem'}" v-if="!e.hideToggleCheckbox">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              v-model="geoItemsMeta.show[e.name]"
              :disabled="!geoItemsMeta.show[e.name] && isMaxVisibleGeoItemLayersReached"
              @change="changeGeoItemLayers(e.name)"
              :id="`geo-items-layer-switch-${e.name}`"
            >
            <label class="custom-control-label" :for="`geo-items-layer-switch-${e.name}`">
              {{e.dispName}} {{geoItemsMeta.countsDisp[e.name]}}
            </label>
          </div>
          <component :is="'geo-item-search-' + e.name"
            :ref="geoItemSearchRef(e.name)"
            v-show="geoItemsMeta.show[e.name]"
            @change="refreshGeoItemLayers({ spinnerMsg: state.ui.waitSpinner.msgDefault })" />
        </div>
      </template>
    </div>
  </div>
  <div class="component-box box-route-search mt8">
    <div class="box-header-bar">
      ルート検索
    </div>
    <div class="box-contents">
      <RouteSearch
        :road-name-disps="masters.kp.roadNameDisps"
        :is-valid-date-params="isValidRouteMovieSearchDateParams"
        @route-search="doRouteMovieSearch"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import RouteSearch from 'src/components/Top/RouteSearch.vue';
import geoItemSearchComponents from 'src/components/Top/geoItemSearchComponents';
import { useTopShellStore } from 'src/composables/useTopView';
import { useGeoItemLayersStore } from 'src/composables/useGeoItemLayers';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';

const {
  state,
  styles,
  masters,
  geoItemsMeta,
  carState,
  groupScopeMap,
  updateShowCarIcons,
  onCarListRowClick,
  onCarSearchParamsChange,
  dtFormat,
} = useTopShellStore();

const {
  isMaxVisibleGeoItemLayersReached,
  changeGeoItemLayers,
  refreshGeoItemLayers,
  geoItemSearchRef,
} = useGeoItemLayersStore();

const { isValidRouteMovieSearchDateParams, doRouteMovieSearch } = useMovieSearchStore();

defineOptions({
  components: {
    RouteSearch,
    ...geoItemSearchComponents,
  },
});
</script>

<style lang="scss" scoped>
.car-list {
  overflow: scroll;
  .fa-video {
    margin: 0 0 0 -2px;
    font-size: 0.9em;
  }
  .fa-stop {
    margin: 0 2px 0 -2px;
    font-size: 0.9em;
  }
}

.disp-option-list {
  .form-group {
    margin: 6px 8px;
    white-space: nowrap;
    &.group-scope {
      display: flex;
      align-items: center;
      .custom-select {
        width: 130px;
        height: 32px;
      }
    }
    &.checkboxes {
      margin: 8px 4px;
    }
  }
}

.data-layer-list {
  overflow: visible;
  .geo-items-layer-switches {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .lbl {
      margin: 0 16px 0 0;
    }
    .form-group {
      margin: 3px 8px;
      width: 124px;
      white-space: nowrap;
    }
  }
}
</style>
